import React from 'react';
import { Text } from '@chakra-ui/react';
import { useCurrency } from 'hooks';

function MarketItemPriceBasis({
  pricingBasis,
}: {
  pricingBasis: string;
}): JSX.Element {
  const pricingName = pricingBasis === 'RC' ? 'RC' : 'Netto';

  return <Text as='span'>{pricingName}</Text>;
}

export function MarketItemPrice({
  prices,
  pricingBasis,
}: {
  prices: number[];
  pricingBasis: string;
}): JSX.Element {
  const { formatWithSymbol } = useCurrency();
  if (!prices) return <Text as='span'>-</Text>;
  if (prices[0] === prices[1]) {
    return (
      <Text as='span'>
        {formatWithSymbol(prices[0])}{' '}
        <MarketItemPriceBasis pricingBasis={pricingBasis} />
      </Text>
    );
  }
  return (
    <Text as='span'>
      {formatWithSymbol(prices[0])} - {formatWithSymbol(prices[1])}{' '}
      <MarketItemPriceBasis pricingBasis={pricingBasis} />
    </Text>
  );
}
